(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "ad9a4fd8c315bbe3f29e53b9b0ce822d29ed09e5"
};